import React, { useEffect, useState } from "react";
import axios from "axios";
import { Cookies } from "react-cookie";
import Loading from "../Loading";
import { ErrorAlert } from "../middleware/AlertMsg";
import "./apiTransactions.css";
import { getReqResponse } from "../middleware/AxiosApisCall";
import Select from 'react-select'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableFooter,
} from "@mui/material";
import {
  HeaderTableCell,
  StyledTableRow,
  StyledTableCell,
} from "../Partials/TableStyle";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { format, differenceInMonths } from "date-fns";

const ApiTransactions = () => {
  const cookies = new Cookies();
  const token = cookies.get("JWTcookie");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [machineFilter, setMachineFilter] = useState();
  const [isLoading, setLoading] = useState(false);
  const [machines, setMachines] = useState();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [pgTxns, setpgTxns] = useState([]);
  const [refundTxns, setRefundTxns] = useState([]);
  const [pgTotal, setpgTotal] = useState(0);
  const [refundTotal, setRefundTotal] = useState(0);

  const handleInputs = async () => {
    transactionApi();
  };

  const getAllMachine = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrl}/api/getallmachines`, {
        headers: { Authorization: "Bearer " + token },
      });
      const data = res.data.data;
      setMachines(data);
      setLoading(false);
    } catch (error) {
      ErrorAlert({
        title: "Fail",
        message: error.message,
      });
    }
  };
  const custumStyle = {
    control: (provided) => ({
      ...provided,
      width: "300px",
      backgroundColor: "#dee1e2",
      border: "2px solid #dee1e2",

    }),
  };
  useEffect(() => {
    getAllMachine();
  }, []);

  const groupTransactions = (data) => {
    // Function to format datetime correctly
    const formatDateTime = (dateTime) => format(Date.parse(dateTime), "yyyy-MM-dd HH:mm:ss");
  
    // **1. Sort Transactions by DateTime & SlotNo**
    const sortedTransactions = data.sort((a, b) => {
      const dateA = new Date(a.TrnDate);
      const dateB = new Date(b.TrnDate);
      
      if (dateA - dateB !== 0) return dateA - dateB; // Sort by datetime first
      return parseInt(a.SlotNo) - parseInt(b.SlotNo); // Sort by SlotNo
    });
  
    // **2. Group Data**
    const groupedData = sortedTransactions.reduce((acc, item) => {
      item.TrnDate = formatDateTime(item.TrnDate); // Keep full datetime
      const key = `${item.SlotNo}*${item.ItemName}*${item.TrnDate}`;
      
      if (!acc[key]) {
        acc[key] = { ...item, Price: 0, Total: 0 };
      }
      
      acc[key].Price += parseInt(item.Price, 10);
      acc[key].Total += 1;
      
      return acc;
    }, {});
  
    return Object.values(groupedData);
  };

  const transformData = (data) => {
    let newdata = [["Slot No.", "Item Name", "Total Transactions", "Total Amount"]];
    let groupedData = {};

    // Group data by SlotNo
    Object.values(data).forEach((value) => {
        if (!groupedData[value.SlotNo]) {
            groupedData[value.SlotNo] = {
                SlotNo: value.SlotNo,
                ItemName: value.ItemName,
                Total: 0,
                Price: 0
            };
        }
        groupedData[value.SlotNo].Total += value.Total;
        groupedData[value.SlotNo].Price += value.Price;
    });

    // Convert grouped data into an array format
    Object.values(groupedData).forEach((value) => {
        newdata.push([value.SlotNo, value.ItemName, value.Total, value.Price]);
    });

    return newdata;
};



  const autoAdjustColumnWidth = (sheet, data) => {
    const colWidths = data[0].map((_, colIndex) => ({
        wch: Math.max(...data.map(row => (row[colIndex] ? row[colIndex].toString().length : 10))) + 2
    }));
    sheet["!cols"] = colWidths;
};
  const downloadCSV = async () => {

    const pgTrns = transformData(pgTxns);

    const select = document.getElementById("mySelect");
    const selectedValue = select.value; // Get the value
    const selectedText = select.options[select.selectedIndex].text;
    // Add date as the first row
    pgTrns.unshift([`From Date & Time`,`${startDate}`], [`To Date & Time`,`${endDate}`], [`Machine Filter`,`${selectedText}`], [``,``]);
     // Add date row at the beginning
    pgTrns.unshift([` `]);

 
    const workbook = XLSX.utils.book_new();

    const sheet1 = XLSX.utils.aoa_to_sheet(pgTrns);
    // const sheet2 = XLSX.utils.aoa_to_sheet(refundTrns);
        
    // Auto adjust column widths
    autoAdjustColumnWidth(sheet1, pgTrns);
    // autoAdjustColumnWidth(sheet2, refundTrns);

    XLSX.utils.book_append_sheet(workbook, sheet1, "pageTransactions");
    // XLSX.utils.book_append_sheet(workbook, sheet2, "refundTransactions");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, machineFilter + ".xlsx");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const transactionApi = async () => {
    try {
      if (!startDate || !endDate) {
        alert("Please fill in both start and end date fields.");
        return;
      }
      if (!machineFilter || machineFilter.length === 0) {
        alert("Please select Machine.");
        return;
      }
      const sDate = new Date(startDate);
      const eDate = new Date(endDate);
      const diff = differenceInMonths(eDate, sDate);

      if (diff > 1) {
        alert("The date range should not exceed one month.");
        return;
      }
      setLoading(true);
      await getReqResponse(
        "snaxsmart/txns/" +
          machineFilter +
          "?fromdate=" +
          startDate +
          "&todate=" +
          endDate
      )
        .then((res) => {
          if (res[0].pgTxns.length === 0 && res[0].refundTxns.length === 0 && res[0].cashTxns.length===0) {
            ErrorAlert({
              title: "Fail",
              message: "No transactions found.",
            });
            setLoading(false);
            return;
          }
          setpgTotal(res[0].pg);
          setRefundTotal(res[0].refund);
          const pgTxns = res[0].pgTxns.map((txn) => {
            return {
              TrnDate: txn[0],
              TrnMode: txn[1],
              TrnId: txn[2],
              SlotNo: txn[3],
              Price: txn[4],
              ItemName : txn[5],
            };
          });
          const cashTxns = res[0].cashTxns.map((txn) => {
            return {
              TrnDate: txn[0],
              TrnMode: txn[1],
              TrnId: txn[2],
              SlotNo: txn[3],
              Price: txn[4],
              ItemName : txn[5],
            };
          });

          const refundTxns = res[0].refundTxns.map((txn) => {
            return {
              TrnDate: txn[0],
              TrnMode: txn[1],
              TrnId: txn[2],
              SlotNo: txn[3],
              Price: txn[4],
            };
          });
          pgTxns.push(...cashTxns)
          const pgTransactions = groupTransactions(pgTxns);
          const refundTransactions =groupTransactions(refundTxns);
          const data = { pgTxns: pgTransactions, refundTxns: refundTransactions };
          setpgTxns(pgTransactions);
          setRefundTxns(refundTransactions);
          if (data) {
            setLoading(false);
          }
        })
        .catch((err) => {         
          ErrorAlert({
            title: "Fail",
            message: err.response.data.error,
          });
          setLoading(false);
          return;
        });
    } catch (error) {
      ErrorAlert({
        title: "Fail",
        message: error.message,
      });
      setLoading(false);
    }
  };
  const mappedMachines = machines?.map((item) => ({
    value: item.machineid,
    label: item.machinename,
  }));

  return (
    <div className="mainSales">
      <h4 className="reportHead">Transactions</h4>

      <div className="inputform">
        <input
          type="datetime-local"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <input
          type="datetime-local"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
         {/* <Select
           className="dropdown"
          options={mappedMachines}
          name="selectmachine"
          placeholder="Select Machine"
          onChange={(selected) => setMachineFilter(selected?.value || "") }
        /> */}
        <select
          id="mySelect"
          className="dropdown"
          onChange={(e) => setMachineFilter(e.target.value)}
          // onChange={(e) =>
          //   setMachineFilter(e.target.options[e.target.selectedIndex].text)
          // }
        >
          <option value="">Select Machine</option>
          {machines?.map((item, i) => (
            <option key={item.machineid} value={item.machineid}>
              {item.machinename}
            </option>
          ))}
        </select>
       

        <br />
        <button onClick={handleInputs} type="button" className="submit-btn">
          Submit
        </button>
        <button
          onClick={downloadCSV}
          type="button"
          className="downlaodsubmit-btn"
        >
          Download
        </button>
      </div>
      <hr />

      <div className="salesData">
        {/* <h3>Page Transactions</h3> */}
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <StyledTableRow>
                {/* <HeaderTableCell>Date</HeaderTableCell> */}
                <HeaderTableCell>Slot No.</HeaderTableCell>
                <HeaderTableCell>Item Name</HeaderTableCell>
                <HeaderTableCell>Total Transactions</HeaderTableCell>
                <HeaderTableCell>Total Amount</HeaderTableCell>
              </StyledTableRow>
            </TableHead>

            <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Loading />
                </TableCell>
              </TableRow>
            ) : (
              Object.entries(
                pgTxns.reduce((acc, item) => {
                  if (!acc[item.SlotNo]) acc[item.SlotNo] = [];
                  acc[item.SlotNo].push(item);
                  return acc;
                }, {})
              ).map(([slotNo, items]) => {
                // Calculate sum of Total Transactions for this slot
                const slotTotalTransactions = items.reduce((sum, item) => sum + item.Total, 0);
                const slotTotalAmount = items.reduce((sum, item) => sum + item.Price, 0);

                return (
                  <React.Fragment key={slotNo}>                  
                    <StyledTableRow>
                      <StyledTableCell colSpan={1} style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}> {slotNo}</StyledTableCell>
                      <StyledTableCell>{items[0].ItemName}</StyledTableCell>  
                      <StyledTableCell style={{ fontWeight: "bold" }}>{slotTotalTransactions}</StyledTableCell>
                      <StyledTableCell style={{ fontWeight: "bold" }}>{slotTotalAmount}</StyledTableCell>
                    </StyledTableRow>
                  </React.Fragment>
                );
              })
              
            )}
          </TableBody>


            <TableFooter>
              <TableRow>
                <TableCell
                  colSpan={8}
                  align="right"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                  >
                  Total Transactions	: {pgTotal}
                </TableCell>
              </TableRow>
            </TableFooter>

          </Table>
          {/* <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={pgTxns.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          /> */}
        </TableContainer>
        <hr />
        {/* <h3>Refund Transactions</h3>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <StyledTableRow>
                <HeaderTableCell>Date</HeaderTableCell>
                <HeaderTableCell>Payment Mode</HeaderTableCell>
                <HeaderTableCell>Transaction ID</HeaderTableCell>
                <HeaderTableCell>Slot No.</HeaderTableCell>
                <HeaderTableCell>Price</HeaderTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Loading />
                  </TableCell>
                </TableRow>
              ) : (
                refundTxns
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <StyledTableRow
                      key={item.id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#f5f5f5" : "white",
                      }}
                    >
                      <StyledTableCell>{item.TrnDate}</StyledTableCell>
                      <StyledTableCell>{item.TrnMode}</StyledTableCell>
                      <StyledTableCell>{item.TrnId}</StyledTableCell>
                      <StyledTableCell>{item.SlotNo}</StyledTableCell>
                      <StyledTableCell align="right">
                        {item.Price}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell
                  colSpan={8}
                  align="right"
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  Total: {refundTotal}
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, 100]}
            component="div"
            count={refundTxns.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer> */}
      </div>
    </div>
  );
};

export default ApiTransactions;
